import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { IApprovalsTypes, IPatientApprovalsDetails } from 'src/app/_interfaces/approvals/lcaPatientApprovals.interface';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { GenericResponse } from 'src/app/_models/response.model';
import { FilesService } from 'src/app/_services/files/files.service';
import { PatientsApprovalsService } from 'src/app/_services/patients-approvals.service';
import { showNotification } from 'src/app/helpers/show-toast';

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss']
})
export class ApprovalsComponent implements OnInit {

  LcaPatientId: number = 0;
  fileToUpload: File | null = null;
  approvalTypeId: number | null = null;
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'There is no Approvals',
    totalMessage: 'total',
    selectedMessage: ''
  }
  @ViewChild('downloadRef') public downloadRef: TemplateRef<any>;
  approvalsTypes: IApprovalsTypes[] = [];
  patientApprovalsDetails: IPatientApprovalsDetails[] = []

  constructor(
    private patientApprovalsService: PatientsApprovalsService,
    private activatedRoute: ActivatedRoute,
    private filesService: FilesService,/*use it to download file*/
    private datePipe: DatePipe,
    public toastr: ToastrService) {
    this.LcaPatientId = this.activatedRoute.snapshot.params.patientId;
  }

  ngOnInit(): void {
    this.getApprovalsTypes();
    this.getPatientApprovals(this.LcaPatientId, this.currentPage, this.pageSize);
  }

  getPatientApprovals(patientId, currentPage, pageSize) {
    this.patientApprovalsService
      .getPatientApprovals(patientId, currentPage, pageSize)
      .subscribe((response) => {
        this.patientApprovalsDetails = response.data.items;
        this.totalItems = response.data.pagination.totalItems;
        this.initializeColumn();
      })
  }

  getApprovalsTypes() {
    this.patientApprovalsService
      .getApprovalsTypes().subscribe((response: GenericResponse<IApprovalsTypes[]>) => {
        this.approvalsTypes = response.data
      })
  }

  onFileSelected(files: FileList): void {
    this.fileToUpload = files.item(0)
  }

  isFormValid() {
    return Boolean(!this.fileToUpload || !this.LcaPatientId || !this.approvalTypeId)
  }

  upload(): void {
    const formData: FormData = new FormData();
    formData.append('patientId', this.LcaPatientId.toString());
    formData.append('approvalTypeId', this.approvalTypeId.toString());
    formData.append('file', this.fileToUpload);

    this.patientApprovalsService.uploadLcaApprovalData(formData).subscribe({
      next: (response) => {
        let approvalDate = response.data.approvalDetails.approvalDate.slice(0, -1);
        response.data.approvalDetails.approvalDate = approvalDate;
        this.totalItems = this.totalItems + 1;
        this.patientApprovalsDetails.unshift(response.data);
        this.patientApprovalsDetails = [...this.patientApprovalsDetails];
        showNotification(
          'success',
          `The approval has been uploaded successfully for: ${response.data.patient.fullName}`,
          this.toastr
        );
        this.fileToUpload = null;
        this.approvalTypeId = null;
      }

    })
  }

  downloadApprovalFile(approvalDetails: IPatientApprovalsDetails) {
    this.filesService.downloadFile(approvalDetails.approvalDetails.file);
  }

  initializeColumn() {
    this.columns = [
      { prop: 'patient.fullName', name: 'Patient Name' },
      { prop: 'patient.phone', name: 'Mobile Number' },
      { prop: 'approvalDetails.approvalType', name: 'Approval Type' },
      {
        prop: 'approvalDetails.approvalDate', name: 'Approval Date',
        pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a", ) }
      },
      { prop: '', name: 'Approval File', sortable: false, cellTemplate: this.downloadRef },
    ]
  }

  onChangePage(pageDetails: ISmartTablePagination) {
    this.currentPage = pageDetails.offset + 1;
    this.getPatientApprovals(this.LcaPatientId, this.currentPage, this.pageSize);
  }

  

}

